import { aggregateBy, groupBy } from "@progress/kendo-data-query";
import { CustomNumberPipe } from "src/app/pipe/customNumber.pipe";
import { v4 as uuidv4 } from 'uuid';
import { RxCluTickEnteteDocumentType } from "../@schemas/clu_tickentete.schema";
import { RxCluTickLigneDocumentType } from "../@schemas/clu_tickligne.schema";
import { RxCluTickReglementDocumentType } from "../@schemas/clu_tickreglement.schema";
import { RxFClientDocumentType } from "../@schemas/f_client.schema";
import { RxFArticleDocument, RxFTarifQteDocument, RxFTaxeDocument } from "../@services/m-cashdesk-core-rxdb";
import { CluArtFamComptaItem, CluBilanTaxeItem, CluCarteCadeauxItemPickedResult, CluDefaultRemisesResult, CluDiscountResult, CluLotSerieItemPickedResult, CluLotSeriePickedItemResult, CluLoyaltyCardRecompenseParams, CluNomenclatureItem } from "../cashdesk/cashdesk.models";
import { CluTickContextItem } from "./clutickcontext.model";
import { RxFTaxeDocumentType } from "../@schemas/f_taxe.schema";
import moment from "moment";
import { CluDoMoreParams } from "./clumoreparams.model";

export enum CLU_TICKET_STATUS {
    TICKET_ACTIVE = 0,
    TICKET_PAUSED = 1,
    TICKET_CLOSED = 2,
    TICKET_CANCELLED = 3
}

export enum CLU_STORAGE_MODE {
    LOCAL = 0,
    GLOBAL = 1
}

export class CluTickItem {
    ENTETE : RxCluTickEnteteDocumentType;
    LIGNES : RxCluTickLigneDocumentType[];
    REGLEMENTS : RxCluTickReglementDocumentType[];

    private LAST_INSERTED_LIGNE : RxCluTickLigneDocumentType | undefined;

    UPDATE_TICKET_STATUS(TICKET_STATUS : CLU_TICKET_STATUS){
        this.ENTETE.ZTICKET_STATUS = TICKET_STATUS;
        if(TICKET_STATUS == CLU_TICKET_STATUS.TICKET_CLOSED || CLU_TICKET_STATUS.TICKET_CANCELLED) this.ENTETE.DO_DATEFIN = moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
    }

    UPDATE_STORAGE_MODE(STORAGE_MODE : CLU_STORAGE_MODE){
        this.ENTETE.ZSTORAGE_MODE = STORAGE_MODE;
    }

    UPDATE_TIERS(CLIENT : RxFClientDocumentType, DO_MORE_PARAMS : CluDoMoreParams){
        this.ENTETE.DO_TIERS = CLIENT.CT_NUM;
        this.ENTETE.CT_INTITULE = CLIENT.CT_INTITULE;
        this.ENTETE.DO_DEVISE = 0;
        this.ENTETE.DO_DEVISELIB = '';
        this.ENTETE.DO_COURS = 0;
        this.ENTETE.DO_DEVISE_INV = 0;
        this.ENTETE.DO_DEVISE_FORMAT = '';
        this.ENTETE.DO_COORD04 = '';
        if(CLIENT.N_DEVISE && CLIENT.N_DEVISE > 0) {
            this.ENTETE.DO_DEVISE = CLIENT.N_DEVISE;
            this.ENTETE.DO_DEVISELIB = CLIENT.N_DEVISELIB;
            this.ENTETE.DO_COURS = CLIENT.N_DEVISE_COURS;
            this.ENTETE.DO_DEVISE_FORMAT = CLIENT.N_DEVISE_FORMAT;
        }
        this.ENTETE.CT_TAUX01 = CLIENT.CT_TAUX01;
        this.ENTETE.CA_NUM = CLIENT.CA_NUM ?? '';
        this.ENTETE.DO_MOREPARAMS_JSON = JSON.stringify(DO_MORE_PARAMS);
    }

    ADD_LIGNE(LIGNE : RxCluTickLigneDocumentType) : RxCluTickLigneDocumentType {
        if(!LIGNE.DL_GIFTCARD && LIGNE.DL_LCREC != 1 && LIGNE.LS_NOSERIE == '' && this.LAST_INSERTED_LIGNE && this.LAST_INSERTED_LIGNE.DL_VALORISE == 1 && this.LAST_INSERTED_LIGNE.AR_REF == LIGNE.AR_REF && this.LAST_INSERTED_LIGNE.DE_NO == LIGNE.DE_NO &&
            this.LAST_INSERTED_LIGNE.DE_NO == LIGNE.DE_NO && this.LAST_INSERTED_LIGNE.EU_ENUMERE == LIGNE.EU_ENUMERE && this.LAST_INSERTED_LIGNE.DL_PRIXUNITAIRE == LIGNE.DL_PRIXUNITAIRE && this.LAST_INSERTED_LIGNE.DL_REMISE_LIB == LIGNE.DL_REMISE_LIB &&
            this.LAST_INSERTED_LIGNE.AG_NO1 == LIGNE.AG_NO1 && this.LAST_INSERTED_LIGNE.AG_NO2 == LIGNE.AG_NO2 && LIGNE.EU_QTE == LIGNE.DL_QTE && this.LAST_INSERTED_LIGNE.DL_QTE > 0){
            let M_INDEX = this.LIGNES.findIndex(m => m.MD_CBMARQ == this.LAST_INSERTED_LIGNE?.MD_CBMARQ);
            if(M_INDEX > -1) {
                this.LIGNES[M_INDEX].EU_QTE! += LIGNE.EU_QTE!;
                this.LIGNES[M_INDEX].DL_QTE += LIGNE.DL_QTE;
                this.LIGNES[M_INDEX].DL_MONTANTHT += LIGNE.DL_MONTANTHT;
                this.LIGNES[M_INDEX].DL_MONTANTTTC += LIGNE.DL_MONTANTTTC;
                this.LIGNES[M_INDEX].DL_REMISE_MT = (this.LIGNES[M_INDEX].DL_REMISE_MT ?? 0) + (LIGNE.DL_REMISE_MT ?? 0);
                this.LIGNES[M_INDEX].DL_MONTANTTTC_AVANTREMISE = (this.LIGNES[M_INDEX].DL_MONTANTTTC_AVANTREMISE ?? 0) + (LIGNE.DL_MONTANTTTC_AVANTREMISE ?? 0);
                this.DL_RECALCUL_TOTAUX_LIGNES(this.LIGNES[M_INDEX]);
                this.LAST_INSERTED_LIGNE = this.LIGNES[M_INDEX];
            }
        }
        else {
            if(this.LIGNES.length == 0) { this.ENTETE.DO_DATEDEBUT = moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'; }
            this.LIGNES.push(LIGNE);
            this.LAST_INSERTED_LIGNE = LIGNE;
        }
        this.DO_RECALCUL_ENTETE();
        return this.LAST_INSERTED_LIGNE;
    }

    DELETE_LIGNE(MD_CBMARQ : number){
        if(this.LAST_INSERTED_LIGNE && this.LAST_INSERTED_LIGNE.MD_CBMARQ == MD_CBMARQ) { this.LAST_INSERTED_LIGNE = undefined; }
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            if(M.EST_SOUSTOTAL) { this.LIGNES.forEach(l=> { if(l.DL_NOSOUSTOTAL == M.DL_NO) { l.DL_NOSOUSTOTAL = 0; } }) }
            this.LIGNES.splice(M_INDEX, 1);

            if(!M.EST_SOUSTOTAL && M.DL_NOSOUSTOTAL > 0) {
                let ROWS_SAME_SUBTOTAL = this.LIGNES.filter(w=> !w.EST_SOUSTOTAL && w.DL_NO != M.DL_NO && w.DL_NOSOUSTOTAL == M.DL_NOSOUSTOTAL);
                if(ROWS_SAME_SUBTOTAL.length == 0) {
                    let SUB_TOTAL_ROW = this.LIGNES.find(l=> l.DL_NO == M.DL_NOSOUSTOTAL);
                    if(SUB_TOTAL_ROW) {
                        this.DELETE_LIGNE(SUB_TOTAL_ROW.MD_CBMARQ);
                    }
                }
            }
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    DELETE_LIGNES(MD_CBMARQ_LIST : number[]){
        MD_CBMARQ_LIST.forEach(MD_CBMARQ => this.DELETE_LIGNE(MD_CBMARQ));
    }

    ADD_SOUSTOTAL(ST_INDEX : number = -1) : number {
        if (this.LIGNES.length == 0) return -1;
        this.LAST_INSERTED_LIGNE = undefined;
        let _subTotalItem : RxCluTickLigneDocumentType = {
            PK_ID : uuidv4(),
            MD_SITEGID : this.ENTETE.MD_SITEGID,
            MD_SITE : this.ENTETE.MD_SITE,
            MD_CAISSE : this.ENTETE.MD_CAISSE,
            MD_CAISSIER : this.ENTETE.MD_CAISSIER,
            MD_CAISSIERGID : this.ENTETE.MD_CAISSIERGID,
            MD_CAISSE_SESSION : this.ENTETE.MD_CAISSE_SESSION,
            MD_DATE_CREATION : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            MD_CBMARQ : this.LIGNES.length == 0 ? 1 : Math.max(...this.LIGNES.map(x=> x.MD_CBMARQ)) + 1,
            DL_NO : this.LIGNES.length == 0 ? 1 : Math.max(...this.LIGNES.map(x=> x.MD_CBMARQ)) + 1,
            DO_PIECE : this.ENTETE.DO_PIECE,
            DO_PIECE_INTERNAL : this.ENTETE.DO_PIECE_INTERNAL,
            MD_DOGID : this.ENTETE.MD_DOGID,
            DL_LIGNE : this.LIGNES.length == 0 ? 1000 : Math.max(...this.LIGNES.map(x=> x.DL_LIGNE)) + 1000,
            AR_REF : '',
            FA_CODEFAMILLE : '',
            DL_DESIGN : 'Sous-Total',
            DL_QTE : 0,
            DL_PRIXUNITAIRE : 0,
            DL_REMISE01REM_VALEUR : 0,
            DL_REMISE01REM_TYPE : 0,
            DL_TAXE1 : 0,
            DL_CODETAXE1 : '',
            DL_TYPETAUX1 : 0,
            DL_TYPETAXE1 : 0,
            EU_QTE : 0,
            EU_ENUMERE : '',
            DL_TTC : 0,
            DL_PUTTC : 0,
            DL_MONTANTHT : 0,
            DL_MONTANTTTC : 0,
            DL_VALORISE : 0,
            DL_NOSOUSTOTAL : 0,
            EST_SOUSTOTAL : true,
            NBLIGNES_SOUSTOTAL : 0
        };
        if(ST_INDEX < 0) { this.LIGNES.push(_subTotalItem); }
        else { this.LIGNES.splice(ST_INDEX, 0, _subTotalItem); }
        this.DO_RECALCUL_SOUS_TOTAUX();
        return _subTotalItem.MD_CBMARQ;
    }

    UPDATE_DL_QTE(MD_CBMARQ : number, DL_QTE : number, AR_UNITEVEN : string){
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            M.DL_QTE = DL_QTE;
            M.EU_QTE = DL_QTE;
            M.EU_ENUMERE = AR_UNITEVEN;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    UPDATE_DL_REMISE(MD_CBMARQ : number, REMISE_PARAMS : CluDiscountResult){
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            M.DL_REMISE01REM_TYPE = REMISE_PARAMS.DL_REMISE01REM_TYPE; M.DL_REMISE02REM_TYPE = REMISE_PARAMS.DL_REMISE02REM_TYPE; M.DL_REMISE03REM_TYPE = REMISE_PARAMS.DL_REMISE03REM_TYPE;
            M.DL_REMISE01REM_VALEUR = REMISE_PARAMS.DL_REMISE01REM_VALEUR; M.DL_REMISE02REM_VALEUR = REMISE_PARAMS.DL_REMISE02REM_VALEUR; M.DL_REMISE03REM_VALEUR = REMISE_PARAMS.DL_REMISE03REM_VALEUR;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    UPDATE_DL_PUTTC(MD_CBMARQ : number, DL_PUTTC : number) {
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            if(!M.DL_TTC) return;
            M.DL_PUTTC = DL_PUTTC;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
            M.DL_PRIXUNITAIRE = M.DL_MONTANTHT / M.DL_QTE;
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    UPDATE_DL_PRIXUNITAIRE(MD_CBMARQ : number, DL_PRIXUNITAIRE : number) {
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            if(M.DL_TTC == 1) return;
            M.DL_PRIXUNITAIRE = DL_PRIXUNITAIRE;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
            M.DL_PUTTC = M.DL_MONTANTTTC / M.DL_QTE;
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    UPDATE_EU_QTE(MD_CBMARQ : number, EU_QTE : number, DL_QTE : number, EU_ENUMERE : string){
        let M_INDEX = this.LIGNES.findIndex(a=> a.MD_CBMARQ == MD_CBMARQ);
        if(M_INDEX > - 1){
            let M = this.LIGNES[M_INDEX];
            M.EU_QTE = EU_QTE;
            M.DL_QTE = DL_QTE;
            M.EU_ENUMERE = EU_ENUMERE;
            //M.DL_MONTANTHT = M.DL_QTE * M.DL_PRIXUNITAIRE;
            //M.DL_MONTANTTTC = M.DL_QTE * M.DL_PUTTC!;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
        }
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    REORDER_LIGNES(){
        this.LAST_INSERTED_LIGNE = undefined;
        this.DO_RECALCUL_SOUS_TOTAUX();
    }

    ADD_REGLEMENT(REGLEMENT : RxCluTickReglementDocumentType) : RxCluTickReglementDocumentType {
        this.REGLEMENTS = [...this.REGLEMENTS, REGLEMENT];
        this.DO_RECALCUL_ENTETE();
        return REGLEMENT;
    }

    private DO_RECALCUL_SOUS_TOTAUX(){
        const ITEMS_ARRAYS = this.splitList_SOUS_TOTAUX(this.LIGNES);
        const SOUS_TOTAUX_INDEXES = this.splitList_SOUS_TOTAUX_INDEX(this.LIGNES);
        SOUS_TOTAUX_INDEXES.forEach((SOUS_TOTAL_INDEX, INDEX) => {
            let SUB_TOTAL_ROW = this.LIGNES[SOUS_TOTAL_INDEX];
            let ITEMS_ARRAY = ITEMS_ARRAYS[INDEX];
            ITEMS_ARRAY.forEach((ITEM : RxCluTickLigneDocumentType) => {
                ITEM.DL_NOSOUSTOTAL = SUB_TOTAL_ROW.DL_NO;
            });
            let ITEMS_TO_SUM = ITEMS_ARRAY.filter(m=> m.DL_VALORISE == 1);
            SUB_TOTAL_ROW.DL_QTE = ITEMS_TO_SUM.length == 0 ? 0 : aggregateBy(ITEMS_TO_SUM, [{aggregate : 'sum', field : 'DL_QTE'}])['DL_QTE'].sum ?? 0;
            SUB_TOTAL_ROW.EU_QTE = ITEMS_TO_SUM.length == 0 ? 0 : aggregateBy(ITEMS_TO_SUM, [{aggregate : 'sum', field : 'EU_QTE'}])['EU_QTE'].sum ?? 0;
            SUB_TOTAL_ROW.DL_PRIXUNITAIRE = ITEMS_TO_SUM.length == 0 ? 0 : aggregateBy(ITEMS_TO_SUM, [{aggregate : 'sum', field : 'DL_MONTANTHT'}])['DL_MONTANTHT'].sum ?? 0;
            SUB_TOTAL_ROW.DL_PUTTC = ITEMS_TO_SUM.length == 0 ? 0 : aggregateBy(ITEMS_TO_SUM, [{aggregate : 'sum', field : 'DL_MONTANTTTC'}])['DL_MONTANTTTC'].sum ?? 0;
            SUB_TOTAL_ROW.NBLIGNES_SOUSTOTAL = ITEMS_ARRAY.length;
        });
    }

    private DO_RECALCUL_ENTETE(){
        let DL_VALORISE_ITEMS = this.LIGNES.filter(m=>m.DL_VALORISE == 1);
        this.ENTETE.DO_TOTALHT = DL_VALORISE_ITEMS.length == 0 ? 0 : aggregateBy(DL_VALORISE_ITEMS, [{ aggregate : 'sum', field : 'DL_MONTANTHT' }])['DL_MONTANTHT'].sum ?? 0;
        this.ENTETE.DO_TOTALTTC = DL_VALORISE_ITEMS.length == 0 ? 0 : aggregateBy(DL_VALORISE_ITEMS, [{ aggregate : 'sum', field : 'DL_MONTANTTTC' }])['DL_MONTANTTTC'].sum ?? 0;
        this.ENTETE.DO_MONTANTREGLE = this.REGLEMENTS.length == 0 ? 0 : aggregateBy(this.REGLEMENTS, [{ aggregate : 'sum', field : 'RG_MONTANT' }])['RG_MONTANT'].sum ?? 0;
        this.ENTETE.DO_SOLDETTC = this.ENTETE.DO_TOTALTTC - this.ENTETE.DO_MONTANTREGLE;
        this.ENTETE.DO_NETAPAYER = this.ENTETE.DO_TOTALTTC;
        this.ENTETE.DO_TAXES = this.ENTETE.DO_TOTALTTC - this.ENTETE.DO_TOTALHT;
        this.ENTETE.DO_REMISE_MT = this.LIGNES.map(m=> { let REMISE_MT = m.DL_REMISE_MT ?? 0; if(m.DL_REMISEG == 1) { REMISE_MT = -1 * m.DL_MONTANTTTC; } return REMISE_MT; }).reduce((a, b) => a + b, 0);
        this.ENTETE.DO_RG_ESP_RECU_TOT = this.REGLEMENTS.filter(m => m.RG_ESP_RECU && m.RG_ESP_RECU != 0).length == 0 ? 0 : aggregateBy(this.REGLEMENTS.filter(m => m.RG_ESP_RECU && m.RG_ESP_RECU != 0), [{ aggregate : 'sum', field : 'RG_ESP_RECU' }])['RG_ESP_RECU'].sum ?? 0;
        this.ENTETE.DO_RG_ESP_RENDU_TOT = this.REGLEMENTS.filter(m => m.RG_ESP_RENDU && m.RG_ESP_RENDU != 0).length == 0 ? 0 : aggregateBy(this.REGLEMENTS.filter(m => m.RG_ESP_RENDU && m.RG_ESP_RENDU != 0), [{ aggregate : 'sum', field : 'RG_ESP_RENDU' }])['RG_ESP_RENDU'].sum ?? 0;
        this.ENTETE.DO_RG_MONTANTECART = this.REGLEMENTS.filter(m => m.RG_ECART == 1 && m.RG_MONTANTECART != 0).length == 0 ? 0 : aggregateBy(this.REGLEMENTS.filter(m => m.RG_ECART == 1 && m.RG_MONTANTECART != 0), [{ aggregate : 'sum', field : 'RG_MONTANTECART' }])['RG_MONTANTECART'].sum ?? 0;
        this.ENTETE.DO_MONTANTREGLE_F = this.ENTETE.DO_RG_MONTANTECART && this.ENTETE.DO_RG_MONTANTECART != 0 ? this.ENTETE.DO_MONTANTREGLE + this.ENTETE.DO_RG_MONTANTECART : this.ENTETE.DO_MONTANTREGLE;
    }

    private DL_RECALCUL_TOTAUX_LIGNES(M : RxCluTickLigneDocumentType){
        M.DL_MONTANTHT = M.DL_QTE * M.DL_PRIXUNITAIRE;
        M.DL_MONTANTTTC = M.DL_QTE * M.DL_PUTTC!;
        M.DL_REMISE_LIB = '';
        //if(!M.DL_REMISE01REM_VALEUR || M.DL_REMISE01REM_VALEUR == 0) return;

        let _m_ARTFAMCOMPTA : CluArtFamComptaItem = new CluArtFamComptaItem();
        //_m_ARTFAMCOMPTA.N_CATCOMPTA = this.ENTETE.N_CATCOMPTA;
        _m_ARTFAMCOMPTA.DL_CODETAXE1 = M.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = M.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = M.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = M.DL_TYPETAUX1;
        _m_ARTFAMCOMPTA.DL_CODETAXE2 = M.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = M.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = M.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = M.DL_TYPETAUX2;
        _m_ARTFAMCOMPTA.DL_CODETAXE3 = M.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = M.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = M.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = M.DL_TYPETAUX3;
        switch(M.DL_TTC){
            case 0 :
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0) {
                    switch(M.DL_REMISE01REM_TYPE){
                        case 0 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_REMISE01REM_VALEUR; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTHT = M.DL_MONTANTHT * (100.0 - M.DL_REMISE01REM_VALEUR) / 100.0; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_QTE * M.DL_REMISE01REM_VALEUR; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + 'U'; break; // U
                    }
                }
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0 && M.DL_REMISE02REM_VALEUR && M.DL_REMISE02REM_VALEUR != 0) {
                    switch(M.DL_REMISE02REM_TYPE){
                        case 0 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_REMISE02REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTHT = M.DL_MONTANTHT * (100.0 - M.DL_REMISE02REM_VALEUR) / 100.0; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_QTE * M.DL_REMISE02REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + 'U'; break; // U
                    }
                }
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0 && M.DL_REMISE02REM_VALEUR && M.DL_REMISE02REM_VALEUR != 0 && M.DL_REMISE03REM_VALEUR && M.DL_REMISE03REM_VALEUR != 0) {
                    switch(M.DL_REMISE03REM_TYPE){
                        case 0 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_REMISE03REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTHT = M.DL_MONTANTHT * (100.0 - M.DL_REMISE03REM_VALEUR) / 100.0; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTHT = M.DL_MONTANTHT - M.DL_QTE * M.DL_REMISE03REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + 'U'; break; // U
                    }
                }
                M.DL_MONTANTHT = this.doRoundToActiveFormat(M.DL_MONTANTHT);
                M.DL_MONTANTTTC = this.doConvertHTtoTTC(M.DL_MONTANTHT, M.DL_QTE, _m_ARTFAMCOMPTA);
                M.DL_REMISE_MT = M.DL_QTE == 0 || M.DL_VALORISE == 0 || !M.DL_REMISE01REM_VALEUR || M.DL_REMISE01REM_VALEUR == 0 ? 0 : (M.DL_PRIXUNITAIRE - M.DL_MONTANTHT / M.DL_QTE) * M.DL_QTE;
                M.DL_MONTANTTTC_AVANTREMISE = M.DL_MONTANTTTC + M.DL_REMISE_MT;
                break;
            case 1 :
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0) {
                    switch(M.DL_REMISE01REM_TYPE){
                        case 0 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_REMISE01REM_VALEUR; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTTTC = M.DL_MONTANTTTC * (100.0 - M.DL_REMISE01REM_VALEUR) / 100.0; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_QTE * M.DL_REMISE01REM_VALEUR; M.DL_REMISE_LIB = this.formatNumber_REMISELIB(M.DL_REMISE01REM_VALEUR) + 'U'; break; // U
                    }
                }
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0 && M.DL_REMISE02REM_VALEUR && M.DL_REMISE02REM_VALEUR != 0) {
                    switch(M.DL_REMISE02REM_TYPE){
                        case 0 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_REMISE02REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTTTC = M.DL_MONTANTTTC * (100.0 - M.DL_REMISE02REM_VALEUR) / 100.0; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_QTE * M.DL_REMISE02REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE02REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE02REM_VALEUR) + 'U'; break; // U
                    }
                }
                if(M.DL_REMISE01REM_VALEUR && M.DL_REMISE01REM_VALEUR != 0 && M.DL_REMISE02REM_VALEUR && M.DL_REMISE02REM_VALEUR != 0 && M.DL_REMISE03REM_VALEUR && M.DL_REMISE03REM_VALEUR != 0) {
                    switch(M.DL_REMISE03REM_TYPE){
                        case 0 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_REMISE03REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + 'F'; break; // F
                        case 1 : M.DL_MONTANTTTC = M.DL_MONTANTTTC * (100.0 - M.DL_REMISE03REM_VALEUR) / 100.0; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + '%'; break; // %
                        case 2 : M.DL_MONTANTTTC = M.DL_MONTANTTTC - M.DL_QTE * M.DL_REMISE03REM_VALEUR; M.DL_REMISE_LIB += (M.DL_REMISE03REM_VALEUR >= 0 ? '+' : '') + this.formatNumber_REMISELIB(M.DL_REMISE03REM_VALEUR) + 'U'; break; // U
                    }
                }
                M.DL_MONTANTTTC = this.doRoundToActiveFormat(M.DL_MONTANTTTC);
                M.DL_MONTANTHT = this.doConvertTTCtoHT(M.DL_MONTANTTTC, M.DL_QTE, _m_ARTFAMCOMPTA);
                M.DL_REMISE_MT = M.DL_QTE == 0 || M.DL_VALORISE == 0 || !M.DL_REMISE01REM_VALEUR || M.DL_REMISE01REM_VALEUR == 0 ? 0 : (M.DL_PUTTC! - M.DL_MONTANTTTC / M.DL_QTE) * M.DL_QTE;
                M.DL_MONTANTTTC_AVANTREMISE = M.DL_MONTANTTTC + M.DL_REMISE_MT;
                break;
        }
    }

    FORCE_RECALCUL_TOTAUX(){
        this.DO_RECALCUL_SOUS_TOTAUX();
        this.DO_RECALCUL_ENTETE();
    }

    GET_BILAN_TAXES(_fTaxeItems : RxFTaxeDocumentType[] | undefined = undefined) : CluBilanTaxeItem[] {
        let T_RESULTS : any = {};
        let LIGNES = JSON.parse(JSON.stringify(this.LIGNES));
        let TAXES_TAUX_ONLY = LIGNES.filter((m : any) => { return m.DL_TYPETAUX1 == 0 && m.DL_TYPETAUX2 == 0 && m.DL_TYPETAUX3 == 0; }).length == LIGNES.length;
        LIGNES.forEach((dlItem : any) => {
            let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
            if(dlItem.DL_CODETAXE1 && dlItem.DL_TAXE1 != 0) {
                T_RESULTS[dlItem.DL_CODETAXE1] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1, DL_TYPETAUX : dlItem.DL_TYPETAUX1 }); }
                else if ([2].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1, DL_TYPETAUX : dlItem.DL_TYPETAUX1 }); }
                else if ([3].indexOf(dlItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1, DL_TYPETAUX : dlItem.DL_TYPETAUX1 }); }
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE1, DL_TYPETAXE : dlItem.DL_TYPETAXE1, DL_TAXE : dlItem.DL_TAXE1, DL_TYPETAUX : dlItem.DL_TYPETAUX1 }); }
            }
            if(dlItem.DL_CODETAXE2 && dlItem.DL_TAXE2 != 0) {
                T_RESULTS[dlItem.DL_CODETAXE2] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2, DL_TYPETAUX : dlItem.DL_TYPETAUX2 }); }
                else if ([2].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2, DL_TYPETAUX : dlItem.DL_TYPETAUX2 }); }
                else if ([3].indexOf(dlItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2, DL_TYPETAUX : dlItem.DL_TYPETAUX2 }); }
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE2, DL_TYPETAXE : dlItem.DL_TYPETAXE2, DL_TAXE : dlItem.DL_TAXE2, DL_TYPETAUX : dlItem.DL_TYPETAUX2 }); }
            }
            if(dlItem.DL_CODETAXE3 && dlItem.DL_TAXE3 != 0) {
                T_RESULTS[dlItem.DL_CODETAXE3] = { B_ITEMS : [] };
                if([0,1].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3, DL_TYPETAUX : dlItem.DL_TYPETAUX3 }); }
                else if ([2].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3, DL_TYPETAUX : dlItem.DL_TYPETAUX3 }); }
                else if ([3].indexOf(dlItem.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3, DL_TYPETAUX : dlItem.DL_TYPETAUX3 }); }
                else { TAXES_OTHERS.push({ DL_CODETAXE : dlItem.DL_CODETAXE3, DL_TYPETAXE : dlItem.DL_TYPETAXE3, DL_TAXE : dlItem.DL_TAXE3, DL_TYPETAUX : dlItem.DL_TYPETAUX3 }); }
            }
            dlItem.TAXES_T0T1 = TAXES_T0T1; dlItem.TAXES_T2 = TAXES_T2; dlItem.TAXES_T3 = TAXES_T3; dlItem.TAXES_OTHERS = TAXES_OTHERS;
        });
        if(TAXES_TAUX_ONLY) {
            LIGNES.forEach((dlItem : any) => {
                dlItem.TAXES_T2.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT }); });
                dlItem.TAXES_T0T1.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT * (1 + dlItem.TAXES_T2.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) }); });
                dlItem.TAXES_T3.forEach((m : any) => { T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT * (1 + dlItem.TAXES_T2.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) * (1 + dlItem.TAXES_T0T1.map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) }); });
            });
            Object.keys(T_RESULTS).forEach(code => {
                T_RESULTS[code].T_BASE = T_RESULTS[code].B_ITEMS.map((w : any) => w.T_BASE).reduce((a : number, b : number) => a + b, 0);
                T_RESULTS[code].T_TAUX = T_RESULTS[code].B_ITEMS[0].TAXE.DL_TAXE;
                T_RESULTS[code].T_MONTANT = T_RESULTS[code].T_BASE * T_RESULTS[code].T_TAUX / 100.000000;
            });
        }
        else {
            LIGNES.forEach((dlItem : any) => {
                dlItem.TAXES_T2.forEach((m : any) => {
                    switch(m.DL_TYPETAUX) {
                        case 2 : // QTE
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_QTE });
                            break;
                        case 1 : // MONTANT
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : 1 });
                            break;
                        case 0 : // TAUX
                        default :
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_MONTANTHT });
                            break;
                    }
                });
                dlItem.TAXES_T0T1.forEach((m : any) => {
                    switch(m.DL_TYPETAUX) {
                        case 2 : // QTE
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_QTE });
                            break;
                        case 1 : // MONTANT
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : 1 });
                            break;
                        case 0 : // TAUX
                        default :
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({
                                DL_ITEM : dlItem, TAXE : m,
                                T_BASE : dlItem.DL_MONTANTHT * (1 + dlItem.TAXES_T2.filter((w : any) => w.DL_TYPETAUX == 0).map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) +
                                         dlItem.TAXES_T2.filter((w : any) => w.DL_TYPETAUX == 1).map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) +
                                         dlItem.TAXES_T2.filter((w : any) => w.DL_TYPETAUX == 2).map((w : any) => w.DL_TAXE * dlItem.DL_QTE).reduce((a : number, b : number) => a + b, 0)
                            });
                            break;
                    }
                });
                dlItem.TAXES_T3.forEach((m : any) => {
                    switch(m.DL_TYPETAUX) {
                        case 2 : // QTE
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : dlItem.DL_QTE });
                            break;
                        case 1 : // MONTANT
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({ DL_ITEM : dlItem, TAXE : m, T_BASE : 1 });
                            break;
                        case 0 : // TAUX
                        default :
                            T_RESULTS[m.DL_CODETAXE].B_ITEMS.push({
                                DL_ITEM : dlItem, TAXE : m,
                                T_BASE : dlItem.DL_MONTANTHT * (1 + dlItem.TAXES_T2.filter((w : any) => w.DL_TYPETAUX == 0).map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) * (1 + dlItem.TAXES_T0T1.filter((w : any) => w.DL_TYPETAUX == 0).map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) / 100.0000000) +
                                         dlItem.TAXES_T2.filter((w : any) => w.DL_TYPETAUX == 1).map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) + dlItem.TAXES_T0T1.filter((w : any) => w.DL_TYPETAUX == 1).map((w : any) => w.DL_TAXE).reduce((a : number, b : number) => a + b, 0) +
                                         dlItem.TAXES_T2.filter((w : any) => w.DL_TYPETAUX == 2).map((w : any) => w.DL_TAXE * dlItem.DL_QTE).reduce((a : number, b : number) => a + b, 0) + dlItem.TAXES_T0T1.filter((w : any) => w.DL_TYPETAUX == 2).map((w : any) => w.DL_TAXE * dlItem.DL_QTE).reduce((a : number, b : number) => a + b, 0)
                            });
                            break;
                    }
                });
            });
            Object.keys(T_RESULTS).forEach(code => {
                T_RESULTS[code].T_BASE = T_RESULTS[code].B_ITEMS.map((w : any) => w.T_BASE).reduce((a : number, b : number) => a + b, 0);
                T_RESULTS[code].T_TAUX = T_RESULTS[code].B_ITEMS[0].TAXE.DL_TAXE;
                T_RESULTS[code].T_TYPETAUX = T_RESULTS[code].B_ITEMS[0].TAXE.DL_TYPETAUX;
                switch(T_RESULTS[code].T_TYPETAUX) {
                    case 2 : T_RESULTS[code].T_MONTANT = T_RESULTS[code].T_BASE * T_RESULTS[code].T_TAUX; break;
                    case 1 : T_RESULTS[code].T_MONTANT = T_RESULTS[code].T_BASE * T_RESULTS[code].T_TAUX; break;
                    case 0 : default : T_RESULTS[code].T_MONTANT = T_RESULTS[code].T_BASE * T_RESULTS[code].T_TAUX / 100.000000; break;
                }
            });
        }
        let B_ITEMS : CluBilanTaxeItem[] = [];
        Object.keys(T_RESULTS).forEach(code => {
            let B_ITEM = new CluBilanTaxeItem();
            B_ITEM.DL_CODETAXE = code;
            B_ITEM.T_BASE = T_RESULTS[code].T_BASE;
            B_ITEM.T_TAUX = T_RESULTS[code].T_TAUX;
            B_ITEM.T_TYPETAUX = T_RESULTS[code].T_TYPETAUX;
            B_ITEM.T_MONTANT = T_RESULTS[code].T_MONTANT;
            B_ITEMS.push(B_ITEM);
        });
        if(_fTaxeItems && _fTaxeItems.length > 0) {
            B_ITEMS.forEach((m : CluBilanTaxeItem) => {
                let _mTaxe = _fTaxeItems.find(w=> w.TA_CODE == m.DL_CODETAXE);
                if(_mTaxe) { m.DL_TAXELIB = _mTaxe.TA_INTITULE!; }
            });
        }
        return B_ITEMS;
    }

    // #region HELPER FNs
    GENERATE_LIGNE_HELPER_FN(_pItem : RxFArticleDocument, _cItem : CluTickContextItem, _nItem : CluNomenclatureItem | undefined, _lsItem : CluLotSeriePickedItemResult | undefined, _lcRParams : CluLoyaltyCardRecompenseParams | undefined, _gfPickedRes : CluCarteCadeauxItemPickedResult | undefined, DL_QTE : number | undefined) : RxCluTickLigneDocumentType {
        // #region SPECIFICITES TARIFAIRES
        // RECHERCHE SPEC TARIF : FICHE ARTICLE, PAR DEFAULT
        let DL_TTC = _pItem.AR_PRIXTTCLIB == 'PV TTC' ? 1 : 0;
        let DL_PU = _pItem.AR_PRIXVEN;
        // RECHERCHE SPEC TARIF : CLIENT
        let _spec_CLIENT = _cItem.ARTCLIENT_ITEMS.find(m=> m.AC_CATEGORIE == 0 && m.CT_NUM == _cItem.CLIENT.CT_NUM);
        if(_spec_CLIENT) {
            DL_TTC = _spec_CLIENT.AC_PRIXTTC!;
            DL_PU = _spec_CLIENT.AC_PRIXVEN;
        }
        else {
            // RECHERCHE SPEC TARIF : CATEGORIE TARIFAIRE CLIENT
            let _spec_CATTARIF = _cItem.ARTCLIENT_ITEMS.find(m=> m.AC_CATEGORIE == _cItem.CLIENT.N_CATTARIF);
            if(_spec_CATTARIF){
                DL_TTC = _spec_CATTARIF.AC_PRIXTTC!;
                DL_PU = _spec_CATTARIF.AC_PRIXVEN;
            }
        }
        if(_nItem != undefined && _nItem.REF_ARTICLE_ARTGAMME != undefined) {
            // RECHERCHE SPEC TARIF : DECLINAISON TARIF PAR GAMME
            let TARIFGAM_ITEMS = _cItem.TARIFGAM_ITEMS.filter(m=> m.AG_NO1 == _nItem.REF_ARTICLE_ARTGAMME?.AG_NO1 &&  m.AG_NO2 == _nItem.REF_ARTICLE_ARTGAMME?.AG_NO2 && m.TG_PRIX! != 0);
            // RECHERCHE SPEC TARIF : DECLINAISON TARIF PAR GAMME - CLIENT
            let _specTARIFGAM_CLIENT = TARIFGAM_ITEMS.find(m=> m.TG_REFCF == _cItem.CLIENT.CT_NUM);
            if(_specTARIFGAM_CLIENT) { DL_PU = _specTARIFGAM_CLIENT.TG_PRIX!; }
            else {
                // RECHERCHE SPEC TARIF : DECLINAISON TARIF PAR GAMME - CATEGORIE TARIFAIRE
                let _specTARIFGAM_CATTARIF = TARIFGAM_ITEMS.find(m=> m.TG_REFCF.replace('a', '') == _cItem.CLIENT.N_CATTARIF?.toString().padStart(2, '0'));
                if(_specTARIFGAM_CATTARIF){ DL_PU = _specTARIFGAM_CATTARIF.TG_PRIX!; }
            }
        }
        // #endregion
        if(_cItem.ARTICLE.AR_FACTPOIDS == 1) {
            DL_PU = _cItem.ARTICLE.AR_POIDSNET! * DL_PU;
        }
        let DL_TAXE1 = 0, DL_CODETAXE1 = '', DL_TYPETAUX1 = 0, DL_TYPETAXE1 = 0;
        let DL_TAXE2 = 0, DL_CODETAXE2 = '', DL_TYPETAUX2 = 0, DL_TYPETAXE2 = 0;
        let DL_TAXE3 = 0, DL_CODETAXE3 = '', DL_TYPETAUX3 = 0, DL_TYPETAXE3 = 0;
        let _m_ARTFAMCOMPTA : CluArtFamComptaItem | undefined = undefined;
        let _m_ARTCOMPTA = _cItem.ARTCOMPTA_ITEMS.find(m=> m.N_CATCOMPTA == _cItem.CLIENT.N_CATCOMPTA);
        if(_m_ARTCOMPTA) {
            if(!_m_ARTCOMPTA.DL_CODETAXE1){
                _m_ARTFAMCOMPTA = new CluArtFamComptaItem();
                _m_ARTFAMCOMPTA.N_CATCOMPTA = _m_ARTCOMPTA.N_CATCOMPTA;
                _m_ARTFAMCOMPTA.DL_CODETAXE1 = ''; _m_ARTFAMCOMPTA.DL_LIBTAXE1 = ''; _m_ARTFAMCOMPTA.DL_TAXE1 = 0; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = 0; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = 0;
                _m_ARTFAMCOMPTA.DL_CODETAXE2 = ''; _m_ARTFAMCOMPTA.DL_LIBTAXE2 = ''; _m_ARTFAMCOMPTA.DL_TAXE2 = 0; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = 0; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = 0;
                _m_ARTFAMCOMPTA.DL_CODETAXE3 = ''; _m_ARTFAMCOMPTA.DL_LIBTAXE3 = ''; _m_ARTFAMCOMPTA.DL_TAXE3 = 0; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = 0; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = 0;
            }
            else {
                DL_TAXE1 = _m_ARTCOMPTA.DL_TAXE1!; DL_CODETAXE1 = _m_ARTCOMPTA.DL_CODETAXE1!; DL_TYPETAUX1 = _m_ARTCOMPTA.DL_TYPETAUX1!; DL_TYPETAXE1 = _m_ARTCOMPTA.DL_TYPETAXE1!;
                DL_TAXE2 = _m_ARTCOMPTA.DL_TAXE2!; DL_CODETAXE2 = _m_ARTCOMPTA.DL_CODETAXE2!; DL_TYPETAUX2 = _m_ARTCOMPTA.DL_TYPETAUX2!; DL_TYPETAXE2 = _m_ARTCOMPTA.DL_TYPETAXE2!;
                DL_TAXE3 = _m_ARTCOMPTA.DL_TAXE3!; DL_CODETAXE3 = _m_ARTCOMPTA.DL_CODETAXE3!; DL_TYPETAUX3 = _m_ARTCOMPTA.DL_TYPETAUX3!; DL_TYPETAXE3 = _m_ARTCOMPTA.DL_TYPETAXE3!;
                _m_ARTFAMCOMPTA = new CluArtFamComptaItem();
                _m_ARTFAMCOMPTA.N_CATCOMPTA = _m_ARTCOMPTA.N_CATCOMPTA;
                _m_ARTFAMCOMPTA.DL_CODETAXE1 = _m_ARTCOMPTA.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_LIBTAXE1 = _m_ARTCOMPTA.DL_LIBTAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = _m_ARTCOMPTA.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = _m_ARTCOMPTA.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = _m_ARTCOMPTA.DL_TYPETAUX1;
                _m_ARTFAMCOMPTA.DL_CODETAXE2 = _m_ARTCOMPTA.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_LIBTAXE2 = _m_ARTCOMPTA.DL_LIBTAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = _m_ARTCOMPTA.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = _m_ARTCOMPTA.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = _m_ARTCOMPTA.DL_TYPETAUX2;
                _m_ARTFAMCOMPTA.DL_CODETAXE3 = _m_ARTCOMPTA.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_LIBTAXE3 = _m_ARTCOMPTA.DL_LIBTAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = _m_ARTCOMPTA.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = _m_ARTCOMPTA.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = _m_ARTCOMPTA.DL_TYPETAUX3;
            }
        }
        else {
            let _m_FAMCOMPTA = _cItem.FAMCOMPTA_ITEMS.find(m=> m.N_CATCOMPTA == _cItem.CLIENT.N_CATCOMPTA);
            if(_m_FAMCOMPTA) {
                DL_TAXE1 = _m_FAMCOMPTA.DL_TAXE1!; DL_CODETAXE1 = _m_FAMCOMPTA.DL_CODETAXE1!; DL_TYPETAUX1 = _m_FAMCOMPTA.DL_TYPETAUX1!; DL_TYPETAXE1 = _m_FAMCOMPTA.DL_TYPETAXE1!;
                DL_TAXE2 = _m_FAMCOMPTA.DL_TAXE2!; DL_CODETAXE2 = _m_FAMCOMPTA.DL_CODETAXE2!; DL_TYPETAUX2 = _m_FAMCOMPTA.DL_TYPETAUX2!; DL_TYPETAXE2 = _m_FAMCOMPTA.DL_TYPETAXE2!;
                DL_TAXE3 = _m_FAMCOMPTA.DL_TAXE3!; DL_CODETAXE3 = _m_FAMCOMPTA.DL_CODETAXE3!; DL_TYPETAUX3 = _m_FAMCOMPTA.DL_TYPETAUX3!; DL_TYPETAXE3 = _m_FAMCOMPTA.DL_TYPETAXE3!;
                _m_ARTFAMCOMPTA = new CluArtFamComptaItem();
                _m_ARTFAMCOMPTA.N_CATCOMPTA = _m_FAMCOMPTA.N_CATCOMPTA;
                _m_ARTFAMCOMPTA.DL_CODETAXE1 = _m_FAMCOMPTA.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_LIBTAXE1 = _m_FAMCOMPTA.DL_LIBTAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = _m_FAMCOMPTA.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = _m_FAMCOMPTA.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = _m_FAMCOMPTA.DL_TYPETAUX1;
                _m_ARTFAMCOMPTA.DL_CODETAXE2 = _m_FAMCOMPTA.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_LIBTAXE2 = _m_FAMCOMPTA.DL_LIBTAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = _m_FAMCOMPTA.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = _m_FAMCOMPTA.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = _m_FAMCOMPTA.DL_TYPETAUX2;
                _m_ARTFAMCOMPTA.DL_CODETAXE3 = _m_FAMCOMPTA.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_LIBTAXE3 = _m_FAMCOMPTA.DL_LIBTAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = _m_FAMCOMPTA.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = _m_FAMCOMPTA.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = _m_FAMCOMPTA.DL_TYPETAUX3;
            }
        }
        if(_gfPickedRes && !_gfPickedRes.CANCELED) { DL_PU = _gfPickedRes.DL_GF_C_TOTAL_TTC_INIT; }
        let DL_PRIXUNITAIRE = DL_TTC == 1 ? this.doConvertTTCtoHT(DL_PU, 1, _m_ARTFAMCOMPTA) : DL_PU;
        let DL_PUTTC = DL_TTC == 1 ? DL_PU : this.doConvertHTtoTTC(DL_PU, 1, _m_ARTFAMCOMPTA);

        let _tickLigneItem : RxCluTickLigneDocumentType = {
            PK_ID : uuidv4(),
            MD_SITEGID : this.ENTETE.MD_SITEGID,
            MD_SITE : this.ENTETE.MD_SITE,
            MD_CAISSE : this.ENTETE.MD_CAISSE,
            MD_CAISSIER : this.ENTETE.MD_CAISSIER,
            MD_CAISSIERGID : this.ENTETE.MD_CAISSIERGID,
            MD_CAISSE_SESSION : this.ENTETE.MD_CAISSE_SESSION,
            MD_LOCALGID : this.ENTETE.MD_LOCALGID,
            MD_DATE_CREATION : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            MD_CBMARQ : this.LIGNES.length == 0 ? 1 : Math.max(...this.LIGNES.map(x=> x.MD_CBMARQ)) + 1,
            DL_NO : this.LIGNES.length == 0 ? 1 : Math.max(...this.LIGNES.map(x=> x.MD_CBMARQ)) + 1,
            DO_PIECE : this.ENTETE.DO_PIECE,
            DO_PIECE_INTERNAL : this.ENTETE.DO_PIECE_INTERNAL,
            MD_DOGID : this.ENTETE.MD_DOGID,
            DL_LIGNE : this.LIGNES.length == 0 ? 1000 : Math.max(...this.LIGNES.map(x=> x.DL_LIGNE)) + 1000,
            DE_NO : _lsItem ? _lsItem.DE_NO : this.ENTETE.DE_NO,
            DE_INTITULE : _lsItem ? _lsItem.DE_INTITULE : this.ENTETE.DE_INTITULE,
            AR_REF : _pItem.AR_REF,
            FA_CODEFAMILLE : _pItem.FA_FAMNV1,
            AR_REFCOMPOSE : _pItem.AR_NOMENCLLIB.indexOf('COMMERCIALE') > -1 ? _pItem.AR_REF : '',
            DL_DESIGN : _pItem.AR_DESIGN,
            AG_NO1 : 0,
            AG_NO1LIB : '',
            AG_NO2 : 0,
            AG_NO2LIB : '',
            LS_NOSERIE : _lsItem ? _lsItem.LS_NOSERIE : '',
            LS_COMPLEMENT : _lsItem ? _lsItem.LS_COMPLEMENT : '',
            LS_PEREMPTION : _lsItem && _lsItem.LS_PEREMPTION ? _lsItem.LS_PEREMPTION.toISOString() : '',
            LS_FABRICATION : _lsItem && _lsItem.LS_FABRICATION ? _lsItem.LS_FABRICATION.toISOString() : '',
            LS_QTE : _lsItem && _lsItem.LS_QTE > 0 ? 1 : 0,
            DL_QTE : 1,
            DL_PRIXUNITAIRE : DL_PRIXUNITAIRE,
            DL_PRIXUNITAIRE_NC : DL_PRIXUNITAIRE,
            DL_REMISE01REM_VALEUR : 0,
            DL_REMISE01REM_TYPE : 0,
            DL_REMISE02REM_VALEUR : 0,
            DL_REMISE02REM_TYPE : 0,
            DL_REMISE03REM_VALEUR : 0,
            DL_REMISE03REM_TYPE : 0,
            DL_REMISE_LIB : '',
            DL_TAXE1 : DL_TAXE1,
            DL_CODETAXE1 : DL_CODETAXE1,
            DL_TYPETAUX1 : DL_TYPETAUX1,
            DL_TYPETAXE1 : DL_TYPETAXE1,
            DL_TAXE2 : DL_TAXE2,
            DL_CODETAXE2 : DL_CODETAXE2,
            DL_TYPETAUX2 : DL_TYPETAUX2,
            DL_TYPETAXE2 : DL_TYPETAXE2,
            DL_TAXE3 : DL_TAXE3,
            DL_CODETAXE3 : DL_CODETAXE3,
            DL_TYPETAUX3 : DL_TYPETAUX3,
            DL_TYPETAXE3 : DL_TYPETAXE3,
            EU_QTE : 1,
            EU_ENUMERE : _pItem.AR_UNITEVEN,
            DL_TTC : DL_TTC,
            DL_PUTTC : DL_PUTTC,
            DL_PUTTC_NC : DL_PUTTC,
            DL_MONTANTHT : DL_PRIXUNITAIRE,
            DL_MONTANTTTC : DL_PUTTC,
            DL_MONTANTTTC_AVANTREMISE : DL_PUTTC,
            DL_REMISE_MT : 0,
            DL_VALORISE : _pItem.AR_NOMENCLLIB == 'COMMERCIALE / COMPOSANT' ? 0 : 1,
            DL_NOSOUSTOTAL : 0,
            EST_SOUSTOTAL : false,
            DL_LCREC :  _lcRParams && _lcRParams.LC_REC_GID ? 1 : 0,
            DL_LCREC_DATE : _lcRParams && _lcRParams.LC_REC_GID ? moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' : undefined,
            LC_REC_PTS_NB : _lcRParams && _lcRParams.LC_REC_PTS_NB ? _lcRParams.LC_REC_PTS_NB : 0,
            LC_PG_GID : _lcRParams && _lcRParams.LC_PG_GID ? _lcRParams.LC_PG_GID : undefined,
            LC_REC_GID : _lcRParams && _lcRParams.LC_REC_GID ? _lcRParams.LC_REC_GID : undefined,
            LC_REC_TYPE : _lcRParams && _lcRParams.LC_REC_TYPE ? _lcRParams.LC_REC_TYPE : 0,

            DL_GIFTCARD : _gfPickedRes && !_gfPickedRes.CANCELED,
            DL_GF_CARTE_NUM : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_CARTE_NUM : undefined,
            DL_GF_CARTE_DESIGNATION : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_CARTE_DESIGNATION : undefined,
            DL_GF_C_TOTAL_TTC_INIT : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_C_TOTAL_TTC_INIT : 0,
            DL_GF_DATE_DEBUT : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_DATE_DEBUT.toISOString() : undefined,
            DL_GF_DATE_EXP : _gfPickedRes && !_gfPickedRes.CANCELED ? _gfPickedRes.DL_GF_DATE_EXP.toISOString() : undefined
        };
        if(_lsItem && _lsItem.LS_NOSERIE && _lsItem.LS_QTE) {
            _tickLigneItem.LS_QTE = _lsItem.LS_QTE;
            _tickLigneItem.DL_QTE = _lsItem.LS_QTE;
            _tickLigneItem.EU_QTE = _lsItem.LS_QTE;
            _tickLigneItem.DL_MONTANTHT = _tickLigneItem.DL_QTE * _tickLigneItem.DL_PRIXUNITAIRE;
            _tickLigneItem.DL_MONTANTTTC = _tickLigneItem.DL_QTE * _tickLigneItem.DL_PUTTC!;
        }
        if(_tickLigneItem.DL_VALORISE == 0) { _tickLigneItem.DL_LCREC = 0; _tickLigneItem.DL_LCREC_DATE = undefined; _tickLigneItem.LC_REC_PTS_NB = 0; _tickLigneItem.LC_PG_GID = undefined;  _tickLigneItem.LC_REC_GID = undefined; _tickLigneItem.LC_REC_TYPE = undefined; }
        if(_nItem){
            if(_nItem.REF_ARTICLE_ARTGAMME != undefined){
                _tickLigneItem.AG_NO1 = _nItem.REF_ARTICLE_ARTGAMME.AG_NO1;
                _tickLigneItem.AG_NO1LIB = _nItem.REF_ARTICLE_ARTGAMME.AG_NO1LIB;
                _tickLigneItem.AG_NO2 = _nItem.REF_ARTICLE_ARTGAMME.AG_NO2;
                _tickLigneItem.AG_NO2LIB = _nItem.REF_ARTICLE_ARTGAMME.AG_NO2LIB;
            }
            if(_nItem.PARENT_ARTICLE){
                switch(_nItem.PARENT_ARTICLE.AR_NOMENCLLIB) {
                    case 'COMMERCIALE / COMPOSANT' :
                        _tickLigneItem.AR_REFCOMPOSE = _nItem.PARENT_ARTICLE.AR_REF;
                        _tickLigneItem.DL_VALORISE = _nItem.PARENT_ARTICLE.AR_REF == _pItem.AR_REF ? 0 : 1;
                        break;
                    case 'COMMERCIALE / COMPOSE' :
                        _tickLigneItem.AR_REFCOMPOSE = _nItem.PARENT_ARTICLE.AR_REF;
                        _tickLigneItem.DL_VALORISE = _nItem.PARENT_ARTICLE.AR_REF == _pItem.AR_REF ? 1 : 0;
                        break;
                }
            }
            if(_nItem.NOMENCLATURE) {
                _tickLigneItem.DL_QTE = _nItem.NOMENCLATURE.NO_QTE;
                _tickLigneItem.EU_QTE = _nItem.NOMENCLATURE.NO_QTE;
                _tickLigneItem.DL_MONTANTHT = _tickLigneItem.DL_QTE * _tickLigneItem.DL_PRIXUNITAIRE;
                _tickLigneItem.DL_MONTANTTTC = _tickLigneItem.DL_QTE * _tickLigneItem.DL_PUTTC!;
            }
        }
        // #region CONDITIONNEMENT PRINCIPAL ?
        // EXCLUSION DES CAS AVEC NOMENCLATURE VIA !_nItem
        if(!_nItem && _pItem.AR_CONDITION > 0 && _cItem.CONDITION_ITEMS.length > 0){
            let COND_PRINCIPAL = _cItem.CONDITION_ITEMS.find(m=> m.CO_PRINCIPAL == 1);
            if(COND_PRINCIPAL != null) {
                _tickLigneItem.EU_QTE = 1;
                _tickLigneItem.EU_ENUMERE = COND_PRINCIPAL.EC_ENUMERE;
                _tickLigneItem.DL_QTE = COND_PRINCIPAL.EC_QUANTITE;
                _tickLigneItem.DL_MONTANTHT = _tickLigneItem.DL_QTE * _tickLigneItem.DL_PRIXUNITAIRE;
                _tickLigneItem.DL_MONTANTTTC = _tickLigneItem.DL_QTE * _tickLigneItem.DL_PUTTC!;

                // SPECIFICITE TARIFAIRE POUR UN COND PARTICULIER
                let TARIFCOND_ITEM = _cItem.TARIFCOND_ITEMS.find(m=> m.CO_NO == COND_PRINCIPAL!.CO_NO);
                if(TARIFCOND_ITEM != null){
                    let _format = sessionStorage.getItem('CAURIS_LINKUP_FORMAT') || '';
                    let _pipe = new CustomNumberPipe();
                    let _nbDecimales = _pipe.recupererNombreDecimales(_format);
                    if(_tickLigneItem.DL_TTC == 1){
                        _tickLigneItem.DL_MONTANTTTC = _tickLigneItem.EU_QTE * TARIFCOND_ITEM.TC_PRIX;
                        _tickLigneItem.DL_MONTANTHT = this.doConvertTTCtoHT(_tickLigneItem.DL_MONTANTTTC, _tickLigneItem.DL_QTE, _m_ARTFAMCOMPTA);
                        _tickLigneItem.DL_PUTTC = this.doRound(_tickLigneItem.DL_MONTANTTTC / _tickLigneItem.DL_QTE, _nbDecimales);
                        _tickLigneItem.DL_PRIXUNITAIRE = this.doRound(_tickLigneItem.DL_MONTANTHT / _tickLigneItem.DL_QTE, _nbDecimales);
                    }
                    else {
                        _tickLigneItem.DL_MONTANTHT = _tickLigneItem.EU_QTE * TARIFCOND_ITEM.TC_PRIX;
                        _tickLigneItem.DL_MONTANTTTC = this.doConvertHTtoTTC(_tickLigneItem.DL_MONTANTHT, _tickLigneItem.DL_QTE, _m_ARTFAMCOMPTA);
                        _tickLigneItem.DL_PUTTC = this.doRound(_tickLigneItem.DL_MONTANTTTC / _tickLigneItem.DL_QTE, _nbDecimales);
                        _tickLigneItem.DL_PRIXUNITAIRE = this.doRound(_tickLigneItem.DL_MONTANTHT / _tickLigneItem.DL_QTE, _nbDecimales);
                    }
                }
            }
        }
        // #endregion

        // #region DL_QTE Input
        if(DL_QTE && DL_QTE != 0) {
            if(_pItem.AR_SUIVISTOCKLIB && _pItem.AR_SUIVISTOCKLIB!.indexOf('SERI') > - 1) { }
            else if (_pItem.AR_SUIVISTOCKLIB && _pItem.AR_SUIVISTOCKLIB!.indexOf('PAR LOT') > - 1) { }
            else if (_nItem && _nItem.NOMENCLATURE && _nItem.NOMENCLATURE.NO_TYPE == 0) { }
            else {
                _tickLigneItem.DL_QTE = DL_QTE * _tickLigneItem.DL_QTE;
                _tickLigneItem.EU_QTE = DL_QTE * _tickLigneItem.EU_QTE!;
                this.DL_RECALCUL_TOTAUX_LIGNES(_tickLigneItem);
            }
        }
        // #endregion

        let DEF_REMISES_PARAMS = this.GET_DEFAULT_REMISES_PARAMS(_cItem);
        DEF_REMISES_PARAMS.REM_CONFLICT_MODE = this.ENTETE.DO_REM_CONFLICT_MODE!;
        if(DEF_REMISES_PARAMS.SPECREM_FOUND) { this.APPLY_DEFAULT_REMISES(_tickLigneItem, DEF_REMISES_PARAMS); }

        this.APPLY_PROMO_REMISES(_tickLigneItem, _cItem);
        this.APPLY_NOMENCLATURE_PREPARTITION_REMISES(_tickLigneItem, _nItem);

        return _tickLigneItem;
    }

    private doConvertTTCtoHT(DL_PU_TTC : number, DL_QTE : number, _acpItem : CluArtFamComptaItem | undefined) : number {
        if(_acpItem == undefined) return DL_PU_TTC;
        // #region TAXES
        /**
         * DL_TYPETAXE
         * 0 à 4
         * 0 = TVA/débit
         * 1 = TVA/Encaissement
         * 2 = TP/HT
         * 3 = TP/TTC
         * 4 = TP/Poids
         * 5 = TVA/CEE
         * 6 = Surtaxe
         */
        /**
         * DL_TYPETAUX
         * 0 à 2
         * 0 = Taux %
         * 1 = Montant F
         *  2 = Quantité U
         */
        // #endregion
        let HAS_ERROR : boolean = false;
        let NB_TAXES : number = 0;
        if(_acpItem.DL_CODETAXE3 && _acpItem.DL_TAXE3 != undefined && _acpItem.DL_TAXE3 != 0) { NB_TAXES++;
            if(_acpItem.DL_TYPETAXE3 == 4) { let _message = 'DL_TYPETAXE3 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE3 == 5) { let _message = 'DL_TYPETAXE3 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE3 == 6) { let _message = 'DL_TYPETAXE3 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if(_acpItem.DL_CODETAXE2 && _acpItem.DL_TAXE2 != undefined && _acpItem.DL_TAXE2 != 0) { NB_TAXES++;
            if(_acpItem.DL_TYPETAXE2 == 4) { let _message = 'DL_TYPETAXE2 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE2 == 5) { let _message = 'DL_TYPETAXE2 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE2 == 6) { let _message = 'DL_TYPETAXE2 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if(_acpItem.DL_CODETAXE1 && _acpItem.DL_TAXE1 != undefined && _acpItem.DL_TAXE1 != 0) { NB_TAXES++;
            if(_acpItem.DL_TYPETAXE1 == 4) { let _message = 'DL_TYPETAXE1 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE1 == 5) { let _message = 'DL_TYPETAXE1 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE1 == 6) { let _message = 'DL_TYPETAXE1 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if (NB_TAXES == 0) return DL_PU_TTC;
        let TOTAL_TAXES = 0;
        let TAXES_TAUX_ONLY = _acpItem.DL_TYPETAUX1 == 0 && _acpItem.DL_TYPETAUX2 == 0 && _acpItem.DL_TYPETAUX3 == 0;
        if(!HAS_ERROR){
            if(TAXES_TAUX_ONLY) {
                switch(NB_TAXES){
                    case 1 :
                        {
                            TOTAL_TAXES = DL_PU_TTC / (1 + _acpItem.DL_TAXE1! / 100.0000000);
                            break;
                        }
                    case 2 :
                        {
                            let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
                            if([0,1].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }

                            if([0,1].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }

                            //TOTAL_TAXES = DL_PU_TTC / (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) / (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                            TOTAL_TAXES = DL_PU_TTC /
                                          (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) /
                                          (1 + TAXES_T2.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) /
                                          (1 + TAXES_T3.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) /
                                          (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                            break;
                        }
                    case 3 :
                        {
                            let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
                            if([0,1].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }

                            if([0,1].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }

                            if([0,1].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }

                            //TOTAL_TAXES = DL_PU_TTC / (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) / (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                            TOTAL_TAXES = DL_PU_TTC /
                                          (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) /
                                          (1 + TAXES_T2.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) /
                                          (1 + TAXES_T3.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) /
                                          (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                            break;
                        }
                }
            }
            else {
                switch(NB_TAXES){
                    case 1 :
                        {
                            switch(_acpItem.DL_TYPETAUX1) {
                                case 0 : // TAUX %
                                    TOTAL_TAXES = DL_PU_TTC / (1 + _acpItem.DL_TAXE1! / 100.0000000);
                                    break;
                                case 1 : // MONTANT F
                                    TOTAL_TAXES = DL_PU_TTC - _acpItem.DL_TAXE1!;
                                    break;
                                case 2 : // QUANTITE U
                                    TOTAL_TAXES = DL_PU_TTC - _acpItem.DL_TAXE1! * DL_QTE;
                                    break;
                            }
                            break;
                        }
                    case 2 :
                        {
                            let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
                            if([0,1].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }

                            if([0,1].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }

                            const PER_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 0).reduce((a,t) => a + (t.DL_TAXE || 0), 0);
                            const MTT_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 1).reduce((a,t) => a + (t.DL_TAXE || 0), 0);
                            const QTY_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 2).reduce((a,t) => a + (t.DL_TAXE || 0), 0);

                            TOTAL_TAXES =  (DL_PU_TTC - (DL_QTE * (QTY_SUM(TAXES_T0T1) + QTY_SUM(TAXES_T3) + QTY_SUM(TAXES_OTHERS))) - ((MTT_SUM(TAXES_T0T1) + MTT_SUM(TAXES_T3) + MTT_SUM(TAXES_OTHERS))))
                                            / (1 + PER_SUM(TAXES_T0T1) / 100.0000000)
                                            / (1 + PER_SUM(TAXES_T2)  / 100.0000000)
                                            / (1 + PER_SUM(TAXES_T3)  / 100.0000000)
                                            / (1 + PER_SUM(TAXES_OTHERS) / 100.0000000) - (DL_QTE * (QTY_SUM(TAXES_T2))) - ((MTT_SUM(TAXES_T2)));
                            break;
                        }
                    case 3 :
                        {
                            let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
                            if([0,1].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }

                            if([0,1].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }

                            if([0,1].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3, DL_TYPETAUX : _acpItem.DL_TYPETAUX3 }); }
                            else if ([2].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3, DL_TYPETAUX : _acpItem.DL_TYPETAUX3 }); }
                            else if ([3].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3, DL_TYPETAUX : _acpItem.DL_TYPETAUX3 }); }
                            else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3, DL_TYPETAUX : _acpItem.DL_TYPETAUX3 }); }

                            const PER_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 0).reduce((a,t) => a + (t.DL_TAXE || 0), 0);
                            const MTT_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 1).reduce((a,t) => a + (t.DL_TAXE || 0), 0);
                            const QTY_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 2).reduce((a,t) => a + (t.DL_TAXE || 0), 0);

                            TOTAL_TAXES =  (DL_PU_TTC - (DL_QTE * (QTY_SUM(TAXES_T0T1) + QTY_SUM(TAXES_T3) + QTY_SUM(TAXES_OTHERS))) - ((MTT_SUM(TAXES_T0T1) + MTT_SUM(TAXES_T3) + MTT_SUM(TAXES_OTHERS))))
                                            / (1 + PER_SUM(TAXES_T0T1) / 100.0000000)
                                            / (1 + PER_SUM(TAXES_T2)  / 100.0000000)
                                            / (1 + PER_SUM(TAXES_T3)  / 100.0000000)
                                            / (1 + PER_SUM(TAXES_OTHERS) / 100.0000000) - (DL_QTE * (QTY_SUM(TAXES_T2))) - ((MTT_SUM(TAXES_T2)));
                            break;
                        }
                }
            }
        }
        let _format = sessionStorage.getItem('CAURIS_LINKUP_FORMAT') || '';
        let _pipe = new CustomNumberPipe();
        let _nbDecimales = _pipe.recupererNombreDecimales(_format);
        let RESULT = this.doRound(TOTAL_TAXES, _nbDecimales);
        return RESULT;
    }

    private doConvertHTtoTTC(DL_PU_HT : number, DL_QTE : number, _acpItem : CluArtFamComptaItem | undefined) : number {
        if(_acpItem == undefined) return DL_PU_HT;
        // #region TAXES
        /**
         * DL_TYPETAXE
         * 0 à 4
         * 0 = TVA/débit
         * 1 = TVA/Encaissement
         * 2 = TP/HT
         * 3 = TP/TTC
         * 4 = TP/Poids
         * 5 = TVA/CEE
         * 6 = Surtaxe
         */
        /**
         * DL_TYPETAUX
         * 0 à 2
         * 0 = Taux %
         * 1 = Montant F
         *  2 = Quantité U
         */
        // #endregion
        let HAS_ERROR : boolean = false;
        let NB_TAXES = 0;
        if(_acpItem.DL_CODETAXE1 && _acpItem.DL_TAXE1 != undefined && _acpItem.DL_TAXE1 != 0) { NB_TAXES++;
            if(_acpItem.DL_TYPETAXE1 == 4) { let _message = 'DL_TYPETAXE1 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE1 == 5) { let _message = 'DL_TYPETAXE1 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE1 == 6) { let _message = 'DL_TYPETAXE1 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if(_acpItem.DL_CODETAXE2 && _acpItem.DL_TAXE2 != undefined && _acpItem.DL_TAXE2 != 0) { NB_TAXES++;
            if(_acpItem.DL_TYPETAXE2 == 4) { let _message = 'DL_TYPETAXE2 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE2 == 5) { let _message = 'DL_TYPETAXE2 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
            if(_acpItem.DL_TYPETAXE2 == 6) { let _message = 'DL_TYPETAXE2 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); HAS_ERROR = true; }
        }
        if(_acpItem.DL_CODETAXE3 && _acpItem.DL_TAXE3 != undefined && _acpItem.DL_TAXE3 != 0) { NB_TAXES++;
            if(_acpItem.DL_TYPETAXE3 == 4) { let _message = 'DL_TYPETAXE3 : 4 [TP/Poids] : Not Implemented Exception'; alert(_message); console.log(_message); }
            if(_acpItem.DL_TYPETAXE3 == 5) { let _message = 'DL_TYPETAXE3 : 5 [TVA/CEE] : Not Implemented Exception'; alert(_message); console.log(_message); }
            if(_acpItem.DL_TYPETAXE3 == 6) { let _message = 'DL_TYPETAXE3 : 6 [Surtaxe] : Not Implemented Exception'; alert(_message); console.log(_message); }
        }
        if(NB_TAXES == 0) return DL_PU_HT;
        let TOTAL_TAXES : number = 0;
        let TAXES_TAUX_ONLY = _acpItem.DL_TYPETAUX1 == 0 && _acpItem.DL_TYPETAUX2 == 0 && _acpItem.DL_TYPETAUX3 == 0;
        if(!HAS_ERROR){
            if(TAXES_TAUX_ONLY) {
                switch(NB_TAXES){
                    case 1:
                    {
                        TOTAL_TAXES = DL_PU_HT * (1 + _acpItem.DL_TAXE1! / 100.0000000);
                        break;
                    }
                    case 2:
                    {
                        let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
                        if([0,1].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }

                        if([0,1].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }

                        TOTAL_TAXES = DL_PU_HT *
                                          (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) *
                                          (1 + TAXES_T2.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) *
                                          (1 + TAXES_T3.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) *
                                          (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                        break;
                    }
                    case 3:
                    {
                        let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
                        if([0,1].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1 }); }

                        if([0,1].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2 }); }

                        if([0,1].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3 }); }

                        TOTAL_TAXES = DL_PU_HT *
                                          (1 + TAXES_T0T1.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) *
                                          (1 + TAXES_T2.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) *
                                          (1 + TAXES_T3.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000) *
                                          (1 + TAXES_OTHERS.map(m => m.DL_TAXE).reduce((a, b) => a + b, 0) / 100.0000000);
                        break;
                    }
                }
            }
            else {

                switch(NB_TAXES){
                    case 1:
                    {
                        switch(_acpItem.DL_TYPETAUX1) {
                            case 0 : // TAUX %
                                TOTAL_TAXES = DL_PU_HT * (1 + _acpItem.DL_TAXE1! / 100.0000000);
                                break;
                            case 1 : // MONTANT F
                                TOTAL_TAXES = DL_PU_HT + _acpItem.DL_TAXE1!;
                                break;
                            case 2 : // QUANTITE U
                                TOTAL_TAXES = DL_PU_HT + _acpItem.DL_TAXE1! * DL_QTE;
                                break;
                        }
                        break;
                    }
                    case 2:
                    {
                        let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
                        if([0,1].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }

                        if([0,1].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }

                        const PER_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 0).reduce((a,t) => a + (t.DL_TAXE || 0), 0);
                        const MTT_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 1).reduce((a,t) => a + (t.DL_TAXE || 0), 0);
                        const QTY_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 2).reduce((a,t) => a + (t.DL_TAXE || 0), 0);

                        TOTAL_TAXES = (DL_PU_HT + (DL_QTE * (QTY_SUM(TAXES_T2))) + MTT_SUM(TAXES_T2)) *
                                          (1 + PER_SUM(TAXES_T0T1) / 100.0000000) *
                                          (1 + PER_SUM(TAXES_T2)  / 100.0000000) *
                                          (1 + PER_SUM(TAXES_T3)  / 100.0000000) *
                                          (1 + PER_SUM(TAXES_OTHERS) / 100.0000000) + DL_QTE * (QTY_SUM(TAXES_T0T1) + QTY_SUM(TAXES_T3) + QTY_SUM(TAXES_OTHERS)) + (MTT_SUM(TAXES_T0T1) + MTT_SUM(TAXES_T3) + MTT_SUM(TAXES_OTHERS));
                        break;
                    }
                    case 3:
                    {
                        let TAXES_T0T1 : any[] = []; let TAXES_T2 : any[] = []; let TAXES_T3 : any[] = []; let TAXES_OTHERS : any[] = [];
                        if([0,1].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE1!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE1, DL_TAXE : _acpItem.DL_TAXE1, DL_TYPETAUX : _acpItem.DL_TYPETAUX1 }); }

                        if([0,1].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE2!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE2, DL_TAXE : _acpItem.DL_TAXE2, DL_TYPETAUX : _acpItem.DL_TYPETAUX2 }); }

                        if([0,1].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T0T1.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3, DL_TYPETAUX : _acpItem.DL_TYPETAUX3 }); }
                        else if ([2].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T2.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3, DL_TYPETAUX : _acpItem.DL_TYPETAUX3 }); }
                        else if ([3].indexOf(_acpItem.DL_TYPETAXE3!) > -1) { TAXES_T3.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3, DL_TYPETAUX : _acpItem.DL_TYPETAUX3 }); }
                        else { TAXES_OTHERS.push({ DL_TYPETAXE : _acpItem.DL_TYPETAXE3, DL_TAXE : _acpItem.DL_TAXE3, DL_TYPETAUX : _acpItem.DL_TYPETAUX3 }); }

                        const PER_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 0).reduce((a,t) => a + (t.DL_TAXE || 0), 0);
                        const MTT_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 1).reduce((a,t) => a + (t.DL_TAXE || 0), 0);
                        const QTY_SUM = (arr:any[]) => arr.filter(t => t.DL_TYPETAUX === 2).reduce((a,t) => a + (t.DL_TAXE || 0), 0);

                        TOTAL_TAXES = (DL_PU_HT + (DL_QTE * (QTY_SUM(TAXES_T2))) + MTT_SUM(TAXES_T2)) *
                                          (1 + PER_SUM(TAXES_T0T1) / 100.0000000) *
                                          (1 + PER_SUM(TAXES_T2)  / 100.0000000) *
                                          (1 + PER_SUM(TAXES_T3)  / 100.0000000) *
                                          (1 + PER_SUM(TAXES_OTHERS) / 100.0000000) + DL_QTE * (QTY_SUM(TAXES_T0T1) + QTY_SUM(TAXES_T3) + QTY_SUM(TAXES_OTHERS)) + (MTT_SUM(TAXES_T0T1) + MTT_SUM(TAXES_T3) + MTT_SUM(TAXES_OTHERS));
                        break;
                    }
                }
            }
        }
        let _format = sessionStorage.getItem('CAURIS_LINKUP_FORMAT') || '';
        let _pipe = new CustomNumberPipe();
        let _nbDecimales = _pipe.recupererNombreDecimales(_format);
        let RESULT = this.doRound(TOTAL_TAXES, _nbDecimales);
        return RESULT;
    }
    // #endregion

    // #region DEFAULT REMISES
    GET_DEFAULT_REMISES_PARAMS(_cItem : CluTickContextItem) : CluDefaultRemisesResult {
        let DEFAULT_REMISES_PARAMS = new CluDefaultRemisesResult();
        /*
            TYPEREM :
            0 : SIMPLE
            1 : HORS_REMISE

            QTEMONT :
            0 : SIMPLE & HORS_REMISE
            1 : QUANTITE
            2 : MONTANT
            3 : PRIXNET

        */
        let TYPEREM : number = 0;
        let QTEMONT : number = 0;
        let REM : number = 0;
        let TARIFQTE_ITEMS : RxFTarifQteDocument[] = [];

        let _spec_CLIENT = _cItem.ARTCLIENT_ITEMS.find(m=> m.AC_CATEGORIE == 0 && m.CT_NUM == _cItem.CLIENT.CT_NUM);
        if(_spec_CLIENT) {
            TYPEREM = _spec_CLIENT.AC_TYPEREM!;
            QTEMONT = _spec_CLIENT.AC_QTEMONT!;
            REM = _spec_CLIENT.AC_REMISE!;
            TARIFQTE_ITEMS = _cItem.TARIFQTE_ITEMS.filter(w => w.TQ_REFCF == _cItem.CLIENT.CT_NUM);
        }
        else {
            // RECHERCHE SPEC TARIF : CATEGORIE TARIFAIRE CLIENT
            let _spec_CATTARIF = _cItem.ARTCLIENT_ITEMS.find(m=> m.AC_CATEGORIE == _cItem.CLIENT.N_CATTARIF);
            if(_spec_CATTARIF){
                TYPEREM = _spec_CATTARIF.AC_TYPEREM!;
                QTEMONT = _spec_CATTARIF.AC_QTEMONT!;
                REM = _spec_CATTARIF.AC_REMISE!;
                TARIFQTE_ITEMS = _cItem.TARIFQTE_ITEMS.filter(w => w.TQ_REFCF == 'a' + ('00' + _cItem.CLIENT.N_CATTARIF).slice(-2));
            }
        }

        DEFAULT_REMISES_PARAMS.SPECREM_ARTICLE_FOUND = (TYPEREM == 0 && QTEMONT == 0 && REM != 0 ) || // SIMPLE
                                                       (TYPEREM == 1 && QTEMONT == 0) || // HORS_REMISE
                                                       [1,2,3].indexOf(QTEMONT) > -1 && TARIFQTE_ITEMS.length > 0; // QUANTITE | MONTANT

        if(!DEFAULT_REMISES_PARAMS.SPECREM_ARTICLE_FOUND) {
            // FAMILLE
            let _spec_FAM_CLIENT = _cItem.FAMCLIENT_ITEMS.find(m=> m.CT_NUM == _cItem.CLIENT.CT_NUM);
            if(_spec_FAM_CLIENT) {
                TYPEREM = 0;
                QTEMONT = 0;
                REM = _spec_FAM_CLIENT.FC_REMISE;
            }
            else {
                // RECHERCHE SPEC TARIF : CATEGORIE TARIFAIRE CLIENT
                let _spec_FAM_TARIF = _cItem.FAMTARIF_ITEMS.find(m=> m.FT_CATEGORIE == _cItem.CLIENT.N_CATTARIF);
                if(_spec_FAM_TARIF){
                    TYPEREM = _spec_FAM_TARIF.FT_TYPEREM!;
                    QTEMONT = _spec_FAM_TARIF.FT_QTEMONT!;
                    REM = _spec_FAM_TARIF.FT_REMISE!;
                    let FAMTARIFQTE_ITEMS = _cItem.FAMTARIFQTE_ITEMS.filter(w => w.FQ_REFCF == 'a' + ('00' + _cItem.CLIENT.N_CATTARIF).slice(-2));
                    TARIFQTE_ITEMS = FAMTARIFQTE_ITEMS.map(m=> {
                        let rq : any = {};
                        rq.TQ_BORNEINF = m.FQ_BORNEINF;
                        rq.TQ_BORNESUP = m.FQ_BORNESUP;
                        rq.TQ_REMISE01REM_TYPE = m.FQ_REMISE01REM_TYPE;
                        rq.TQ_REMISE01REM_VALEUR = m.FQ_REMISE01REM_VALEUR;
                        rq.TQ_REMISE02REM_TYPE = m.FQ_REMISE02REM_TYPE;
                        rq.TQ_REMISE02REM_VALEUR = m.FQ_REMISE02REM_VALEUR;
                        rq.TQ_REMISE03REM_TYPE = m.FQ_REMISE03REM_TYPE;
                        rq.TQ_REMISE03REM_VALEUR = m.FQ_REMISE03REM_VALEUR;
                        return rq;
                    });
                }
            }

            DEFAULT_REMISES_PARAMS.SPECREM_ARTICLE_FOUND = (TYPEREM == 0 && QTEMONT == 0 && REM != 0 ) || // SIMPLE
                                                           (TYPEREM == 1 && QTEMONT == 0) || // HORS_REMISE
                                                           [1,2,3].indexOf(QTEMONT) > -1 && TARIFQTE_ITEMS.length > 0; // QUANTITE | MONTANT
        }
        DEFAULT_REMISES_PARAMS.TYPEREM = TYPEREM;
        DEFAULT_REMISES_PARAMS.QTEMONT = QTEMONT;
        DEFAULT_REMISES_PARAMS.REM = REM;
        DEFAULT_REMISES_PARAMS.TARIFQTE_ITEMS = TARIFQTE_ITEMS;

        if(_cItem.CLIENT.CT_TAUX01 && _cItem.CLIENT.CT_TAUX01 > 0) {
            DEFAULT_REMISES_PARAMS.REM_CLIENT = _cItem.CLIENT.CT_TAUX01!;
            DEFAULT_REMISES_PARAMS.SPECREM_CLIENT_FOUND = true;
        }
        DEFAULT_REMISES_PARAMS.SPECREM_FOUND = DEFAULT_REMISES_PARAMS.SPECREM_ARTICLE_FOUND || DEFAULT_REMISES_PARAMS.SPECREM_CLIENT_FOUND;
        return DEFAULT_REMISES_PARAMS;
    }

    APPLY_DEFAULT_REMISES(M : RxCluTickLigneDocumentType, _cluRemisesResult  : CluDefaultRemisesResult){
        if(!_cluRemisesResult || !_cluRemisesResult.SPECREM_FOUND) return;
        if(_cluRemisesResult.TYPEREM == 1)
        {
            // HORS_REMISE
            M.DL_REMISE01REM_TYPE = 1; M.DL_REMISE01REM_VALEUR = 0; M.DL_REMISE02REM_TYPE = 1; M.DL_REMISE02REM_VALEUR = 0; M.DL_REMISE03REM_TYPE = 1; M.DL_REMISE03REM_VALEUR = 0;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
            return;
        }
        if(_cluRemisesResult.SPECREM_CLIENT_FOUND && !_cluRemisesResult.SPECREM_ARTICLE_FOUND) {
            M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = 0; M.DL_REMISE02REM_TYPE = 0; M.DL_REMISE02REM_VALEUR = 0; M.DL_REMISE03REM_TYPE = 0; M.DL_REMISE03REM_VALEUR = 0;
            M.DL_REMISE01REM_TYPE = 1; M.DL_REMISE01REM_VALEUR = _cluRemisesResult.REM_CLIENT;
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
        }
        else if (!_cluRemisesResult.SPECREM_CLIENT_FOUND && _cluRemisesResult.SPECREM_ARTICLE_FOUND) {
            /*
                TYPEREM :
                0 : SIMPLE
                1 : HORS_REMISE

                QTEMONT :
                0 : SIMPLE & HORS_REMISE
                1 : QUANTITE
                2 : MONTANT
                3 : PRIXNET
            */
            M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = 0; M.DL_REMISE02REM_TYPE = 0; M.DL_REMISE02REM_VALEUR = 0; M.DL_REMISE03REM_TYPE = 0; M.DL_REMISE03REM_VALEUR = 0;
            switch(_cluRemisesResult.QTEMONT){
                case 0 :
                    switch(_cluRemisesResult.TYPEREM){
                        case 0 : M.DL_REMISE01REM_TYPE = 1; M.DL_REMISE01REM_VALEUR = _cluRemisesResult.REM; break;
                        case 1 : break;
                    }
                    break;
                case 1 :
                    let TARIFQTE_QT_ITEM_M = _cluRemisesResult.TARIFQTE_ITEMS.find(m=> M.DL_QTE > m.TQ_BORNEINF && M.DL_QTE <= m.TQ_BORNESUP);
                    if(TARIFQTE_QT_ITEM_M) {
                        M.DL_REMISE01REM_TYPE = TARIFQTE_QT_ITEM_M.TQ_REMISE01REM_TYPE; M.DL_REMISE01REM_VALEUR = TARIFQTE_QT_ITEM_M.TQ_REMISE01REM_VALEUR;
                        M.DL_REMISE02REM_TYPE = TARIFQTE_QT_ITEM_M.TQ_REMISE02REM_TYPE; M.DL_REMISE02REM_VALEUR = TARIFQTE_QT_ITEM_M.TQ_REMISE02REM_VALEUR;
                        M.DL_REMISE03REM_TYPE = TARIFQTE_QT_ITEM_M.TQ_REMISE03REM_TYPE; M.DL_REMISE03REM_VALEUR = TARIFQTE_QT_ITEM_M.TQ_REMISE03REM_VALEUR;
                    }
                    break;
                case 2 :
                    let TARIFQTE_MT_ITEM_M = _cluRemisesResult.TARIFQTE_ITEMS.find(m=> M.DL_QTE * M.DL_PRIXUNITAIRE > m.TQ_BORNEINF && M.DL_QTE * M.DL_PRIXUNITAIRE <= m.TQ_BORNESUP);
                    if(TARIFQTE_MT_ITEM_M) {
                        M.DL_REMISE01REM_TYPE = TARIFQTE_MT_ITEM_M.TQ_REMISE01REM_TYPE; M.DL_REMISE01REM_VALEUR = TARIFQTE_MT_ITEM_M.TQ_REMISE01REM_VALEUR;
                        M.DL_REMISE02REM_TYPE = TARIFQTE_MT_ITEM_M.TQ_REMISE02REM_TYPE; M.DL_REMISE02REM_VALEUR = TARIFQTE_MT_ITEM_M.TQ_REMISE02REM_VALEUR;
                        M.DL_REMISE03REM_TYPE = TARIFQTE_MT_ITEM_M.TQ_REMISE03REM_TYPE; M.DL_REMISE03REM_VALEUR = TARIFQTE_MT_ITEM_M.TQ_REMISE03REM_VALEUR;
                    }
                    break;
                case 3 :
                    let TARIFQTE_PN_ITEM_M = _cluRemisesResult.TARIFQTE_ITEMS.find(m=> M.DL_QTE > m.TQ_BORNEINF && M.DL_QTE <= m.TQ_BORNESUP);
                    if(TARIFQTE_PN_ITEM_M) {
                        switch(M.DL_TTC){
                            case 0:
                                M.DL_PRIXUNITAIRE = TARIFQTE_PN_ITEM_M.TQ_PRIXNET!;
                                this.DL_RECALCUL_TOTAUX_LIGNES(M);
                                M.DL_PUTTC = M.DL_MONTANTTTC / M.DL_QTE;
                                break;
                            case 1:
                                M.DL_PUTTC = TARIFQTE_PN_ITEM_M.TQ_PRIXNET!;
                                this.DL_RECALCUL_TOTAUX_LIGNES(M);
                                M.DL_PRIXUNITAIRE = M.DL_MONTANTHT / M.DL_QTE;
                                break;
                        }
                    }
                    break;
            }
            this.DL_RECALCUL_TOTAUX_LIGNES(M);
        }
        else {
            /*
                REM_CONFLICT_MODE :
                0 : PRIORITE CLIENT
                1 : PRIORITE ARTICLE
                2 : CUMUL
                3 : CASCADE
                4 : AUCUN
            */
            switch(_cluRemisesResult.REM_CONFLICT_MODE){
                // PRIORITE CLIENT
                case 0 :
                    let _cluRemisesResult_PRIO_CLIENT  : CluDefaultRemisesResult = JSON.parse(JSON.stringify(_cluRemisesResult)); _cluRemisesResult_PRIO_CLIENT.SPECREM_ARTICLE_FOUND = false;
                    this.APPLY_DEFAULT_REMISES(M, _cluRemisesResult_PRIO_CLIENT);
                    break;
                // PRIORITE ARTICLE :
                case 1 :
                    let _cluRemisesResult_PRIO_ARTICLE  : CluDefaultRemisesResult = JSON.parse(JSON.stringify(_cluRemisesResult)); _cluRemisesResult_PRIO_ARTICLE.SPECREM_CLIENT_FOUND = false;
                    this.APPLY_DEFAULT_REMISES(M, _cluRemisesResult_PRIO_ARTICLE);
                    break;
                // CUMUL
                case 2 :
                    let _cluRemisesResult_STEP1_CUMUL_ARTICLE  : CluDefaultRemisesResult = JSON.parse(JSON.stringify(_cluRemisesResult)); _cluRemisesResult_STEP1_CUMUL_ARTICLE.SPECREM_CLIENT_FOUND = false;
                    this.APPLY_DEFAULT_REMISES(M, _cluRemisesResult_STEP1_CUMUL_ARTICLE);
                    M.DL_REMISE01REM_TYPE = 1;
                    if(!M.DL_REMISE01REM_VALEUR) M.DL_REMISE01REM_VALEUR = 0;
                    M.DL_REMISE01REM_VALEUR += _cluRemisesResult.REM_CLIENT;
                    this.DL_RECALCUL_TOTAUX_LIGNES(M);
                    break;
                // CASCADE
                case 3 :
                    let _cluRemisesResult_STEP1_CASCADE_ARTICLE  : CluDefaultRemisesResult = JSON.parse(JSON.stringify(_cluRemisesResult)); _cluRemisesResult_STEP1_CASCADE_ARTICLE.SPECREM_CLIENT_FOUND = false;
                    this.APPLY_DEFAULT_REMISES(M, _cluRemisesResult_STEP1_CASCADE_ARTICLE);
                    if(M.DL_REMISE01REM_VALEUR! != 0) { M.DL_REMISE02REM_TYPE = 1; M.DL_REMISE02REM_VALEUR = _cluRemisesResult.REM_CLIENT; }
                    else { M.DL_REMISE01REM_TYPE = 1; M.DL_REMISE01REM_VALEUR = _cluRemisesResult.REM_CLIENT; }
                    this.DL_RECALCUL_TOTAUX_LIGNES(M);
                    break;
                // AUCUNE REMISE
                case 4 :
                    M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = 0; M.DL_REMISE02REM_TYPE = 0; M.DL_REMISE02REM_VALEUR = 0; M.DL_REMISE03REM_TYPE = 0; M.DL_REMISE03REM_VALEUR = 0;
                    this.DL_RECALCUL_TOTAUX_LIGNES(M);
                    break;
            }
        }
    }

    APPLY_PROMO_REMISES(M : RxCluTickLigneDocumentType, _cItem : CluTickContextItem) {
        if (M.DL_VALORISE != 1) return;
        if (!_cItem.TARIF_ITEMS || _cItem.TARIF_ITEMS.length == 0) return;
        const TODAY = moment().startOf('day');
        _cItem.TARIF_ITEMS.forEach(_tarifItem => {
            if(_tarifItem.TF_REMISE01REM_VALEUR == 0) return;
            // #region VERIFIER PERIODE
            switch(_tarifItem.TF_TYPEP) {
                case 0 : // LE
                    const TF_DATE_PROMOTION = moment(_tarifItem.TF_DEBUT!).startOf('day');
                    if(!TODAY.isSame(TF_DATE_PROMOTION, 'day')) return;
                    break;
                case 1 : // PENDANT
                    const TF_DEBUT = moment(_tarifItem.TF_DEBUT!).startOf('day');
                    const TF_FIN = moment(_tarifItem.TF_FIN!).startOf('day');
                    if(!TODAY.isBetween(TF_DEBUT, TF_FIN, 'day', '[]')) return;
                    break;
                case 2 : // PERMANENCE
                    break;
                case 3 : // A_PARTIR_DE
                    const TF_DATE_PROMOTION_DEBUT = moment(_tarifItem.TF_DEBUT!).startOf('day');
                    if(!TODAY.isSameOrAfter(TF_DATE_PROMOTION_DEBUT, 'day')) return;
                    break;
                case 4 : // JUSQUAU
                    const TF_DATE_PROMOTION_FIN = moment(_tarifItem.TF_FIN!).startOf('day');
                    if(!TODAY.isSameOrBefore(TF_DATE_PROMOTION_FIN, 'day')) return;
                    break;
            }
            // #endregion
            let IS_ELLIGIBLE : boolean = true;
            // #region VERIFIER ELLIGIBILITE
            const TARIFSELECT_ITEMS = !_cItem.TARIFSELECT_ITEMS ? [] : _cItem.TARIFSELECT_ITEMS.filter(m => m.TF_NO == _tarifItem.TF_NO);
            const TARIFSELECT_ITEMS_FAMILLE = TARIFSELECT_ITEMS.filter(m => m.TS_INTERES == 0);
            const TARIFSELECT_ITEMS_ARTICLE = TARIFSELECT_ITEMS.filter(m => m.TS_INTERES == 1);
            const TARIFSELECT_ITEMS_CATEGORIE = TARIFSELECT_ITEMS.filter(m => m.TS_INTERES == 2);
            const TARIFSELECT_ITEMS_CLIENT = TARIFSELECT_ITEMS.filter(m => m.TS_INTERES == 3);
            if (IS_ELLIGIBLE && TARIFSELECT_ITEMS_FAMILLE.length > 0) {
                IS_ELLIGIBLE = TARIFSELECT_ITEMS_FAMILLE.find(m => m.TS_REF == _cItem.ARTICLE.FA_FAMNV1) != undefined;
            }
            if (IS_ELLIGIBLE && TARIFSELECT_ITEMS_ARTICLE.length > 0) {
                IS_ELLIGIBLE = TARIFSELECT_ITEMS_ARTICLE.find(m => m.TS_REF == _cItem.ARTICLE.AR_REF) != undefined;
            }
            if (IS_ELLIGIBLE && TARIFSELECT_ITEMS_CATEGORIE.length > 0) {
                IS_ELLIGIBLE = TARIFSELECT_ITEMS_CATEGORIE.find(m => parseInt(m.TS_REF!) == _cItem.CLIENT.N_CATTARIF) != undefined;
            }
            if (IS_ELLIGIBLE && TARIFSELECT_ITEMS_CLIENT.length > 0) {
                IS_ELLIGIBLE = TARIFSELECT_ITEMS_CLIENT.find(m => m.TS_REF == _cItem.CLIENT.CT_NUM) != undefined;
            }
            // #endregion
            if (IS_ELLIGIBLE) {
                // #region APPLIQUER_REMISES
                M.DL_REMISE01REM_TYPE = _tarifItem.TF_REMISE01REM_TYPE!; M.DL_REMISE01REM_VALEUR = _tarifItem.TF_REMISE01REM_VALEUR!;
                M.DL_REMISE02REM_TYPE = _tarifItem.TF_REMISE02REM_TYPE!; M.DL_REMISE02REM_VALEUR = _tarifItem.TF_REMISE02REM_VALEUR!;
                M.DL_REMISE03REM_TYPE = _tarifItem.TF_REMISE03REM_TYPE!; M.DL_REMISE03REM_VALEUR = _tarifItem.TF_REMISE03REM_VALEUR!;
                // #endregion
                this.DL_RECALCUL_TOTAUX_LIGNES(M);
            }
        });
    }

    APPLY_NOMENCLATURE_PREPARTITION_REMISES(M : RxCluTickLigneDocumentType, _nItem : CluNomenclatureItem | undefined) {
        if(!(_nItem && _nItem.NOMENCLATURE && _nItem.NOMENCLATURE.NO_REPARTITION && _nItem.NOMENCLATURE.NO_REPARTITION > 0 && _nItem.PARENT_ARTICLE)) return;
        // #region NOMENCLATURE AVEC % REPARTITION
        let _parentTickLignes = this.LIGNES .filter(m => m.AR_REF === _nItem.PARENT_ARTICLE.AR_REF && m.AR_REFCOMPOSE === _nItem.PARENT_ARTICLE.AR_REF) .sort((a, b) => b.DL_LIGNE - a.DL_LIGNE);
        let _matchTickLigneParent = _parentTickLignes.length > 0 ? _parentTickLignes[0] : undefined;
        switch(_nItem.PARENT_ARTICLE.AR_NOMENCLLIB) {
            case 'COMMERCIALE / COMPOSANT' :
                if(_matchTickLigneParent) {
                    let VALEUR_REMISE = M.DL_PUTTC! * M.DL_QTE - _matchTickLigneParent.DL_MONTANTTTC * _nItem.NOMENCLATURE.NO_REPARTITION! / 100;
                    let VALEUR_REMISE_F = this.doRoundToActiveFormat(VALEUR_REMISE);
                    // #region APPLIQUER_REMISES
                    M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = VALEUR_REMISE_F!;
                    M.DL_REMISE02REM_TYPE = 1; M.DL_REMISE02REM_VALEUR = 0;
                    M.DL_REMISE03REM_TYPE = 1; M.DL_REMISE03REM_VALEUR = 0;
                    // #endregion
                    this.DL_RECALCUL_TOTAUX_LIGNES(M);
                }
                break;
            case 'COMMERCIALE / COMPOSE' :
                if(_matchTickLigneParent) {
                    let _m_ARTFAMCOMPTA : CluArtFamComptaItem = new CluArtFamComptaItem();
                    _m_ARTFAMCOMPTA.DL_CODETAXE1 = M.DL_CODETAXE1; _m_ARTFAMCOMPTA.DL_TAXE1 = M.DL_TAXE1; _m_ARTFAMCOMPTA.DL_TYPETAXE1 = M.DL_TYPETAXE1; _m_ARTFAMCOMPTA.DL_TYPETAUX1 = M.DL_TYPETAUX1;
                    _m_ARTFAMCOMPTA.DL_CODETAXE2 = M.DL_CODETAXE2; _m_ARTFAMCOMPTA.DL_TAXE2 = M.DL_TAXE2; _m_ARTFAMCOMPTA.DL_TYPETAXE2 = M.DL_TYPETAXE2; _m_ARTFAMCOMPTA.DL_TYPETAUX2 = M.DL_TYPETAUX2;
                    _m_ARTFAMCOMPTA.DL_CODETAXE3 = M.DL_CODETAXE3; _m_ARTFAMCOMPTA.DL_TAXE3 = M.DL_TAXE3; _m_ARTFAMCOMPTA.DL_TYPETAXE3 = M.DL_TYPETAXE3; _m_ARTFAMCOMPTA.DL_TYPETAUX3 = M.DL_TYPETAUX3;

                    if(_matchTickLigneParent.DL_TTC == 0) {
                        let DL_MONTANTHT = _matchTickLigneParent.DL_MONTANTHT * _nItem.NOMENCLATURE.NO_REPARTITION! / 100;
                        let DL_MONTANTTTC = this.doConvertHTtoTTC(DL_MONTANTHT, M.DL_QTE, _m_ARTFAMCOMPTA);
                        M.DL_MONTANTHT = DL_MONTANTHT;
                        M.DL_MONTANTTTC = DL_MONTANTTTC;
                    }
                    else {
                        let DL_MONTANTTTC = _matchTickLigneParent.DL_MONTANTTTC * _nItem.NOMENCLATURE.NO_REPARTITION! / 100;
                        let DL_MONTANTHT = this.doConvertTTCtoHT(DL_MONTANTTTC, M.DL_QTE, _m_ARTFAMCOMPTA);
                        M.DL_MONTANTHT = DL_MONTANTHT;
                        M.DL_MONTANTTTC = DL_MONTANTTTC;
                    }
                    let VALEUR_REMISE = 0;
                    if(M.DL_TTC == 0) { VALEUR_REMISE = M.DL_PRIXUNITAIRE! * M.DL_QTE - M.DL_MONTANTHT; }
                    else { VALEUR_REMISE = M.DL_PUTTC! * M.DL_QTE - M.DL_MONTANTTTC; }
                    let VALEUR_REMISE_F = this.doRoundToActiveFormat(VALEUR_REMISE);
                    // #region APPLIQUER_REMISES
                    M.DL_REMISE01REM_TYPE = 0; M.DL_REMISE01REM_VALEUR = VALEUR_REMISE_F!;
                    M.DL_REMISE02REM_TYPE = 1; M.DL_REMISE02REM_VALEUR = 0;
                    M.DL_REMISE03REM_TYPE = 1; M.DL_REMISE03REM_VALEUR = 0;
                    // #endregion
                    this.DL_RECALCUL_TOTAUX_LIGNES(M);
                }
                break;
        }
        // #endregion
    }
    // #endregion

    // #region Utils
    private splitList_SOUS_TOTAUX(liste: RxCluTickLigneDocumentType[]): RxCluTickLigneDocumentType[][] {
        return liste.reduce((acc : RxCluTickLigneDocumentType[][], objet: RxCluTickLigneDocumentType) => {
            // Vérifiez si l'objet est un séparateur
            if (objet.EST_SOUSTOTAL) {
                // Ajoutez une nouvelle sous-liste
                acc.push([]);
            } else {
                // Ajoutez l'objet à la dernière sous-liste
                acc[acc.length - 1].push(objet);
            }
            return acc;
        }, [[]]);
    }
    private splitList_SOUS_TOTAUX_INDEX(liste: RxCluTickLigneDocumentType[]): number[] {
        let SOUS_TOTAUX_INDEXES : number[] = [];
        liste.forEach((ITEM, INDEX) => {
            if(ITEM.EST_SOUSTOTAL) {
                SOUS_TOTAUX_INDEXES.push(INDEX);
            }
        })
        return SOUS_TOTAUX_INDEXES;
    }
    private formatNumber_REMISELIB(_value : number) {
        return Number.isInteger(_value) || _value % 1 === 0 ? _value.toFixed(0) : _value.toString();
    }

    private doRound(num : number, decimalPlaces = 0) {
       var p = Math.pow(10, decimalPlaces);
       var n = (num * p) * (1 + Number.EPSILON);
       return Math.round(n) / p;
    }

    private doRoundToActiveFormat(num : number) : number {
        let _format = sessionStorage.getItem('CAURIS_LINKUP_FORMAT') || '';
        if(!_format) return num;
        let _pipe = new CustomNumberPipe();
        let _nbDecimales = _pipe.recupererNombreDecimales(_format);
        return this.doRound(num, _nbDecimales);
    }
    // #endregion

}
